/**
 * @fileoverview Subscribe to window size changes, but only on the
 * client. This module creates an event emitter interface over the
 * window to allow for easy window size tracking across the server and
 * browser environments.
 */

import Diode from 'diode'

const listener = Diode()

let dimensions = { width: window.innerWidth, height: window.innerHeight }
let previousDimensions = dimensions

const ResizeService = {
  set(width, height) {
    previousDimensions = dimensions
    dimensions = { width, height }
    listener.publish(dimensions, previousDimensions)
  },

  get() {
    return dimensions
  },

  listen(callback, scope) {
    listener.subscribe(callback, scope)
  },

  ignore(callback, scope) {
    listener.ignore(callback, scope)
  },

  forceUpdate() {
    queue()
  }
}

ResizeService.set(window.innerWidth, window.innerHeight)

let requestFrame = window.requestIdleCallback || window.requestAnimationFrame
let cancelFrame = window.cancelIdleCallback || window.cancelAnimationFrame

let frame = null

function dispatch() {
  ResizeService.set(window.innerWidth, window.innerHeight)

  if (frame) {
    cancelFrame(frame)
    frame = null
  }
}

function queue() {
  // Process frames one at a time, don't buffer up a bunch of changes
  if (frame == null) {
    frame = requestFrame(dispatch, { timeout: 200 })
  }
}

window.addEventListener('resize', queue, { passive: true })

export default ResizeService



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/services/resize.js